import React from 'react'

export default function FindAndReplace(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <path
          fill="currentColor"
          d="M30.37 6.93 24.04.79c-.3-.4-.89-.59-1.39-.59H4.85C3.07.2 1.48 1.68 1.48 3.56v28.89c0 1.88 1.58 3.36 3.36 3.36H27.7c1.88 0 3.36-1.48 3.36-3.27V8.61c.1-.69-.2-1.29-.69-1.68Zm-.39 24.63c0 1.68-1.39 3.17-3.07 3.17H5.74c-1.68 0-3.07-1.39-3.07-3.17V4.45c0-1.68 1.39-3.17 3.07-3.17h16.33a2 2 0 0 1 1.39.59l5.84 5.74c.4.4.69.99.59 1.58v22.36h.1v.02h-.01v-.01Z"
        />
        <path
          fill="currentColor"
          fill-opacity=".1"
          d="M22.35 1.23c.49 0 1.06.19 1.35.58l5.89 5.84c.29.39.57.97.57 1.46h.01v22.56c0 1.75-1.45 3.11-3.09 3.11H5.76c-1.73 0-3.09-1.46-3.09-3.11V4.44c0-1.75 1.35-3.21 3.09-3.21h16.59Zm-5.09 7.92a4.72 4.72 0 1 0 0 9.44 4.72 4.72 0 0 0 0-9.44Z"
        />
        <path
          fill="currentColor"
          d="M21.11 9.92a5.493 5.493 0 0 0-3.9-1.62c-1.47 0-2.86.57-3.9 1.62a5.493 5.493 0 0 0-1.62 3.9c0 1.33.47 2.59 1.32 3.59l-.58.58-.83-.83-3.15 3.15c-.3.3-.47.71-.47 1.14 0 .43.17.84.47 1.14.3.3.71.47 1.14.47.43 0 .84-.17 1.14-.47l3.15-3.15-.84-.84.58-.58c1 .86 2.26 1.32 3.59 1.32 1.47 0 2.86-.57 3.9-1.62a5.51 5.51 0 0 0 1.62-3.9c0-1.47-.57-2.86-1.62-3.9ZM10.12 21.97a.75.75 0 1 1-1.06-1.06l1.23-1.23 1.06 1.06-1.23 1.23Zm1.84-1.84-1.06-1.06.69-.69 1.06 1.06-.69.69Zm8.54-3.02c-.88.88-2.05 1.36-3.29 1.36-1.24 0-2.41-.48-3.29-1.36a4.622 4.622 0 0 1-1.36-3.29c0-1.24.48-2.41 1.36-3.29.88-.88 2.05-1.36 3.29-1.36 1.24 0 2.41.48 3.29 1.36.88.88 1.36 2.05 1.36 3.29 0 1.24-.48 2.41-1.36 3.29ZM9.97 10.54c.11.32.45.51.77.41.3-.1.5-.45.4-.78-.44-1.41.15-2.92 1.41-3.61.66-.36 1.43-.46 2.14-.28l-.29.16c-.29.19-.37.56-.2.85.17.29.55.39.84.22l1.46-.89c.3-.18.38-.55.2-.84l-.91-1.49c-.18-.3-.55-.41-.84-.22-.3.18-.38.55-.2.84l.09.16c-.98-.22-2.01-.1-2.92.4-1.78.97-2.61 3.09-1.99 5.07h.01l.02-.02v.02h.01Zm14.51 6.24c-.12-.32-.46-.5-.78-.39-.3.1-.49.46-.38.79.48 1.39-.08 2.92-1.32 3.64-.65.38-1.42.5-2.13.34l.29-.17c.28-.19.36-.57.18-.86a.616.616 0 0 0-.84-.2l-1.43.93c-.29.18-.36.56-.18.85l.94 1.46c.19.3.56.39.84.2.29-.18.36-.56.18-.85l-.09-.16c.99.2 2.01.05 2.91-.48 1.75-1.02 2.53-3.16 1.85-5.11l-.02.02h-.02v-.01Z"
        />
      </svg>
    </div>
  )
}
